var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sendlike",attrs:{"liked":_vm.itsLiked(_vm.slug)},on:{"click":function($event){return _vm.requestLike()}}},[_c('i',{staticClass:"fa fa-heart-o",attrs:{"aria-hidden":"true"}}),_c('span',[_vm._v(_vm._s(_vm.localLikes))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eddb486","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/like.vue
// module id = null
// module chunks = 